module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

	module.exports = require("babel-runtime/core-js/json/stringify");

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = require("babel-runtime/helpers/classCallCheck");

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = require("babel-runtime/helpers/createClass");

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_superagent__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_superagent___default = __WEBPACK_IMPORTED_MODULE_3_superagent__ && __WEBPACK_IMPORTED_MODULE_3_superagent__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_superagent__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_superagent__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_superagent___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_superagent___default });
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	var HEADER_X_VERSION_ID = 'x-version-id';
	var HEADER_X_CLUSTER_ID = 'x-cluster-id';
	var HEADER_TOKEN = 'token';
	var HEADER_BEARER = 'BEARER';
	var HEADER_AUTH = 'Authorization';
	
	var Client = function () {
	    function Client() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, Client);
	
	        this.teamId = '';
	        this.serverVersion = '';
	        this.clusterId = '';
	        this.logToConsole = false;
	        this.useToken = false;
	        this.token = '';
	        this.url = '';
	        this.urlVersion = '/api/v3';
	        this.defaultHeaders = {
	            'X-Requested-With': 'XMLHttpRequest'
	        };
	
	        this.translations = {
	            connectionError: 'There appears to be a problem with your internet connection.',
	            unknownError: 'We received an unexpected status code from the server.'
	        };
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(Client, [{
	        key: 'setUrl',
	        value: function setUrl(url) {
	            this.url = url;
	        }
	    }, {
	        key: 'setAcceptLanguage',
	        value: function setAcceptLanguage(locale) {
	            this.defaultHeaders['Accept-Language'] = locale;
	        }
	    }, {
	        key: 'setTeamId',
	        value: function setTeamId(id) {
	            this.teamId = id;
	        }
	    }, {
	        key: 'getTeamId',
	        value: function getTeamId() {
	            if (!this.teamId) {
	                console.error('You are trying to use a route that requires a team_id, but you have not called setTeamId() in client.jsx'); // eslint-disable-line no-console
	            }
	
	            return this.teamId;
	        }
	    }, {
	        key: 'getServerVersion',
	        value: function getServerVersion() {
	            return this.serverVersion;
	        }
	    }, {
	        key: 'getBaseRoute',
	        value: function getBaseRoute() {
	            return '' + this.url + this.urlVersion;
	        }
	    }, {
	        key: 'getAdminRoute',
	        value: function getAdminRoute() {
	            return '' + this.url + this.urlVersion + '/admin';
	        }
	    }, {
	        key: 'getGeneralRoute',
	        value: function getGeneralRoute() {
	            return '' + this.url + this.urlVersion + '/general';
	        }
	    }, {
	        key: 'getLicenseRoute',
	        value: function getLicenseRoute() {
	            return '' + this.url + this.urlVersion + '/license';
	        }
	    }, {
	        key: 'getTeamsRoute',
	        value: function getTeamsRoute() {
	            return '' + this.url + this.urlVersion + '/teams';
	        }
	    }, {
	        key: 'getTeamNeededRoute',
	        value: function getTeamNeededRoute() {
	            return '' + this.url + this.urlVersion + '/teams/' + this.getTeamId();
	        }
	    }, {
	        key: 'getChannelsRoute',
	        value: function getChannelsRoute() {
	            return '' + this.url + this.urlVersion + '/teams/' + this.getTeamId() + '/channels';
	        }
	    }, {
	        key: 'getChannelNameRoute',
	        value: function getChannelNameRoute(channelName) {
	            return '' + this.url + this.urlVersion + '/teams/' + this.getTeamId() + '/channels/name/' + channelName;
	        }
	    }, {
	        key: 'getChannelNeededRoute',
	        value: function getChannelNeededRoute(channelId) {
	            return '' + this.url + this.urlVersion + '/teams/' + this.getTeamId() + '/channels/' + channelId;
	        }
	    }, {
	        key: 'getCommandsRoute',
	        value: function getCommandsRoute() {
	            return '' + this.url + this.urlVersion + '/teams/' + this.getTeamId() + '/commands';
	        }
	    }, {
	        key: 'getEmojiRoute',
	        value: function getEmojiRoute() {
	            return '' + this.url + this.urlVersion + '/emoji';
	        }
	    }, {
	        key: 'getHooksRoute',
	        value: function getHooksRoute() {
	            return '' + this.url + this.urlVersion + '/teams/' + this.getTeamId() + '/hooks';
	        }
	    }, {
	        key: 'getPostsRoute',
	        value: function getPostsRoute(channelId) {
	            return '' + this.url + this.urlVersion + '/teams/' + this.getTeamId() + '/channels/' + channelId + '/posts';
	        }
	    }, {
	        key: 'getUsersRoute',
	        value: function getUsersRoute() {
	            return '' + this.url + this.urlVersion + '/users';
	        }
	    }, {
	        key: 'getFilesRoute',
	        value: function getFilesRoute() {
	            return '' + this.url + this.urlVersion + '/teams/' + this.getTeamId() + '/files';
	        }
	    }, {
	        key: 'getOAuthRoute',
	        value: function getOAuthRoute() {
	            return '' + this.url + this.urlVersion + '/oauth';
	        }
	    }, {
	        key: 'getUserNeededRoute',
	        value: function getUserNeededRoute(userId) {
	            return '' + this.url + this.urlVersion + '/users/' + userId;
	        }
	    }, {
	        key: 'setTranslations',
	        value: function setTranslations(messages) {
	            this.translations = messages;
	        }
	    }, {
	        key: 'enableLogErrorsToConsole',
	        value: function enableLogErrorsToConsole(enabled) {
	            this.logToConsole = enabled;
	        }
	    }, {
	        key: 'useHeaderToken',
	        value: function useHeaderToken() {
	            this.useToken = true;
	            if (this.token !== '') {
	                this.defaultHeaders[HEADER_AUTH] = HEADER_BEARER + ' ' + this.token;
	            }
	        }
	    }, {
	        key: 'track',
	        value: function track(category, action, label, property, value) {// eslint-disable-line no-unused-vars
	            // NO-OP for inherited classes to override
	        }
	    }, {
	        key: 'trackPage',
	        value: function trackPage() {
	            // NO-OP for inherited classes to override
	        }
	    }, {
	        key: 'handleError',
	        value: function handleError(err, res) {// eslint-disable-line no-unused-vars
	            // NO-OP for inherited classes to override
	        }
	    }, {
	        key: 'handleResponse',
	        value: function handleResponse(methodName, successCallback, errorCallback, err, res) {
	            if (res && res.header) {
	                this.serverVersion = res.header[HEADER_X_VERSION_ID];
	                if (res.header[HEADER_X_VERSION_ID]) {
	                    this.serverVersion = res.header[HEADER_X_VERSION_ID];
	                }
	
	                this.clusterId = res.header[HEADER_X_CLUSTER_ID];
	                if (res.header[HEADER_X_CLUSTER_ID]) {
	                    this.clusterId = res.header[HEADER_X_CLUSTER_ID];
	                }
	            }
	
	            if (err) {
	                // test to make sure it looks like a server JSON error response
	                var e = null;
	                if (res && res.body && res.body.id) {
	                    e = res.body;
	                }
	
	                var msg = '';
	
	                if (e) {
	                    msg = 'method=' + methodName + ' msg=' + e.message + ' detail=' + e.detailed_error + ' rid=' + e.request_id;
	                } else {
	                    msg = 'method=' + methodName + ' status=' + err.status + ' statusCode=' + err.statusCode + ' err=' + err;
	
	                    if (err.status === 0 || !err.status) {
	                        e = { message: this.translations.connectionError };
	                    } else {
	                        e = { message: this.translations.unknownError + ' (' + err.status + ')' };
	                    }
	                }
	
	                if (this.logToConsole) {
	                    console.error(msg); // eslint-disable-line no-console
	                    console.error(e); // eslint-disable-line no-console
	                }
	
	                this.track('api', 'api_weberror', methodName, 'message', msg);
	
	                this.handleError(err, res);
	
	                if (errorCallback) {
	                    errorCallback(e, err, res);
	                    return;
	                }
	            }
	
	            if (successCallback) {
	                successCallback(res.body, res);
	            }
	        }
	
	        // General Routes Section
	
	    }, {
	        key: 'getClientConfig',
	        value: function getClientConfig(success, error) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getGeneralRoute() + '/client_props').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getClientConfig', success, error));
	        }
	    }, {
	        key: 'getPing',
	        value: function getPing(success, error) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getGeneralRoute() + '/ping').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getPing', success, error));
	        }
	    }, {
	        key: 'logClientError',
	        value: function logClientError(msg) {
	            var l = {};
	            l.level = 'ERROR';
	            l.message = msg;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getGeneralRoute() + '/log_client').set(this.defaultHeaders).type('application/json').accept('application/json').send(l).end(this.handleResponse.bind(this, 'logClientError', null, null));
	        }
	
	        // Admin / Licensing Routes Section
	
	    }, {
	        key: 'reloadConfig',
	        value: function reloadConfig(success, error) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getAdminRoute() + '/reload_config').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'reloadConfig', success, error));
	        }
	    }, {
	        key: 'recycleDatabaseConnection',
	        value: function recycleDatabaseConnection(success, error) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getAdminRoute() + '/recycle_db_conn').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'recycleDatabaseConnection', success, error));
	        }
	    }, {
	        key: 'getTranslations',
	        value: function getTranslations(url, success, error) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(url).set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getTranslations', success, error));
	        }
	    }, {
	        key: 'getComplianceReports',
	        value: function getComplianceReports(success, error) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getAdminRoute() + '/compliance_reports').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getComplianceReports', success, error));
	        }
	    }, {
	        key: 'uploadBrandImage',
	        value: function uploadBrandImage(image, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getAdminRoute() + '/upload_brand_image').set(this.defaultHeaders).accept('application/json').attach('image', image, image.name).end(this.handleResponse.bind(this, 'uploadBrandImage', success, error));
	        }
	    }, {
	        key: 'saveComplianceReports',
	        value: function saveComplianceReports(job, success, error) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getAdminRoute() + '/save_compliance_report').set(this.defaultHeaders).type('application/json').accept('application/json').send(job).end(this.handleResponse.bind(this, 'saveComplianceReports', success, error));
	        }
	    }, {
	        key: 'getLogs',
	        value: function getLogs(success, error) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getAdminRoute() + '/logs').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getLogs', success, error));
	        }
	    }, {
	        key: 'getClusterStatus',
	        value: function getClusterStatus(success, error) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getAdminRoute() + '/cluster_status').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getClusterStatus', success, error));
	        }
	    }, {
	        key: 'getServerAudits',
	        value: function getServerAudits(success, error) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getAdminRoute() + '/audits').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getServerAudits', success, error));
	        }
	    }, {
	        key: 'getConfig',
	        value: function getConfig(success, error) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getAdminRoute() + '/config').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getConfig', success, error));
	        }
	    }, {
	        key: 'getAnalytics',
	        value: function getAnalytics(name, teamId, success, error) {
	            var url = this.getAdminRoute() + '/analytics/';
	            if (teamId == null) {
	                url += name;
	            } else {
	                url += teamId + '/' + name;
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(url).set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getAnalytics', success, error));
	        }
	    }, {
	        key: 'getTeamAnalytics',
	        value: function getTeamAnalytics(teamId, name, success, error) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getAdminRoute() + '/analytics/' + teamId + '/' + name).set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getTeamAnalytics', success, error));
	        }
	    }, {
	        key: 'saveConfig',
	        value: function saveConfig(config, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getAdminRoute() + '/save_config').set(this.defaultHeaders).type('application/json').accept('application/json').send(config).end(this.handleResponse.bind(this, 'saveConfig', success, error));
	        }
	    }, {
	        key: 'testEmail',
	        value: function testEmail(config, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getAdminRoute() + '/test_email').set(this.defaultHeaders).type('application/json').accept('application/json').send(config).end(this.handleResponse.bind(this, 'testEmail', success, error));
	        }
	    }, {
	        key: 'getClientLicenceConfig',
	        value: function getClientLicenceConfig(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getLicenseRoute() + '/client_config').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getClientLicenceConfig', success, error));
	        }
	    }, {
	        key: 'removeLicenseFile',
	        value: function removeLicenseFile(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getLicenseRoute() + '/remove').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'removeLicenseFile', success, error));
	        }
	    }, {
	        key: 'uploadLicenseFile',
	        value: function uploadLicenseFile(license, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getLicenseRoute() + '/add').set(this.defaultHeaders).accept('application/json').attach('license', license, license.name).end(this.handleResponse.bind(this, 'uploadLicenseFile', success, error));
	
	            this.track('api', 'api_license_upload');
	        }
	    }, {
	        key: 'importSlack',
	        value: function importSlack(fileData, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getTeamNeededRoute() + '/import_team').set(this.defaultHeaders).accept('application/octet-stream').send(fileData).end(this.handleResponse.bind(this, 'importSlack', success, error));
	        }
	    }, {
	        key: 'exportTeam',
	        value: function exportTeam(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getTeamsRoute() + '/export_team').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'exportTeam', success, error));
	        }
	    }, {
	        key: 'signupTeam',
	        value: function signupTeam(email, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getTeamsRoute() + '/signup').set(this.defaultHeaders).type('application/json').accept('application/json').send({ email: email }).end(this.handleResponse.bind(this, 'signupTeam', success, error));
	
	            this.track('api', 'api_teams_signup');
	        }
	    }, {
	        key: 'adminResetMfa',
	        value: function adminResetMfa(userId, success, error) {
	            var data = {};
	            data.user_id = userId;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getAdminRoute() + '/reset_mfa').set(this.defaultHeaders).type('application/json').accept('application/json').send(data).end(this.handleResponse.bind(this, 'adminResetMfa', success, error));
	        }
	    }, {
	        key: 'adminResetPassword',
	        value: function adminResetPassword(userId, newPassword, success, error) {
	            var data = {};
	            data.new_password = newPassword;
	            data.user_id = userId;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getAdminRoute() + '/reset_password').set(this.defaultHeaders).type('application/json').accept('application/json').send(data).end(this.handleResponse.bind(this, 'adminResetPassword', success, error));
	
	            this.track('api', 'api_admin_reset_password');
	        }
	    }, {
	        key: 'ldapSyncNow',
	        value: function ldapSyncNow(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getAdminRoute() + '/ldap_sync_now').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'ldapSyncNow', success, error));
	        }
	    }, {
	        key: 'ldapTest',
	        value: function ldapTest(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getAdminRoute() + '/ldap_test').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'ldap_test', success, error));
	        }
	
	        // Team Routes Section
	
	    }, {
	        key: 'createTeamFromSignup',
	        value: function createTeamFromSignup(teamSignup, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getTeamsRoute() + '/create_from_signup').set(this.defaultHeaders).type('application/json').accept('application/json').send(teamSignup).end(this.handleResponse.bind(this, 'createTeamFromSignup', success, error));
	        }
	    }, {
	        key: 'findTeamByName',
	        value: function findTeamByName(teamName, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getTeamsRoute() + '/find_team_by_name').set(this.defaultHeaders).type('application/json').accept('application/json').send({ name: teamName }).end(this.handleResponse.bind(this, 'findTeamByName', success, error));
	        }
	    }, {
	        key: 'createTeam',
	        value: function createTeam(team, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getTeamsRoute() + '/create').set(this.defaultHeaders).type('application/json').accept('application/json').send(team).end(this.handleResponse.bind(this, 'createTeam', success, error));
	
	            this.track('api', 'api_users_create', '', 'email', team.name);
	        }
	    }, {
	        key: 'updateTeam',
	        value: function updateTeam(team, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getTeamNeededRoute() + '/update').set(this.defaultHeaders).type('application/json').accept('application/json').send(team).end(this.handleResponse.bind(this, 'updateTeam', success, error));
	
	            this.track('api', 'api_teams_update_name');
	        }
	    }, {
	        key: 'getAllTeams',
	        value: function getAllTeams(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getTeamsRoute() + '/all').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getAllTeams', success, error));
	        }
	    }, {
	        key: 'getAllTeamListings',
	        value: function getAllTeamListings(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getTeamsRoute() + '/all_team_listings').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getAllTeamListings', success, error));
	        }
	    }, {
	        key: 'getMyTeam',
	        value: function getMyTeam(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getTeamNeededRoute() + '/me').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getMyTeam', success, error));
	        }
	    }, {
	        key: 'getTeamMembers',
	        value: function getTeamMembers(teamId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getTeamsRoute() + '/members/' + teamId).set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getTeamMembers', success, error));
	        }
	    }, {
	        key: 'inviteMembers',
	        value: function inviteMembers(data, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getTeamNeededRoute() + '/invite_members').set(this.defaultHeaders).type('application/json').accept('application/json').send(data).end(this.handleResponse.bind(this, 'inviteMembers', success, error));
	
	            this.track('api', 'api_teams_invite_members');
	        }
	    }, {
	        key: 'addUserToTeam',
	        value: function addUserToTeam(teamId, userId, success, error) {
	            var nonEmptyTeamId = teamId;
	            if (nonEmptyTeamId === '') {
	                nonEmptyTeamId = this.getTeamId();
	            }
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getTeamsRoute() + '/' + nonEmptyTeamId + '/add_user_to_team').set(this.defaultHeaders).type('application/json').accept('application/json').send({ user_id: userId }).end(this.handleResponse.bind(this, 'addUserToTeam', success, error));
	
	            this.track('api', 'api_teams_invite_members');
	        }
	    }, {
	        key: 'addUserToTeamFromInvite',
	        value: function addUserToTeamFromInvite(data, hash, inviteId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getTeamsRoute() + '/add_user_to_team_from_invite').set(this.defaultHeaders).type('application/json').accept('application/json').send({ hash: hash, data: data, invite_id: inviteId }).end(this.handleResponse.bind(this, 'addUserToTeam', success, error));
	
	            this.track('api', 'api_teams_invite_members');
	        }
	    }, {
	        key: 'removeUserFromTeam',
	        value: function removeUserFromTeam(teamId, userId, success, error) {
	            var nonEmptyTeamId = teamId;
	            if (nonEmptyTeamId === '') {
	                nonEmptyTeamId = this.getTeamId();
	            }
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getTeamsRoute() + '/' + nonEmptyTeamId + '/remove_user_from_team').set(this.defaultHeaders).type('application/json').accept('application/json').send({ user_id: userId }).end(this.handleResponse.bind(this, 'removeUserFromTeam', success, error));
	
	            this.track('api', 'api_teams_remove_members');
	        }
	    }, {
	        key: 'getInviteInfo',
	        value: function getInviteInfo(inviteId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getTeamsRoute() + '/get_invite_info').set(this.defaultHeaders).type('application/json').accept('application/json').send({ invite_id: inviteId }).end(this.handleResponse.bind(this, 'getInviteInfo', success, error));
	        }
	
	        // User Routes Setions
	
	    }, {
	        key: 'createUser',
	        value: function createUser(user, success, error) {
	            this.createUserWithInvite(user, null, null, null, success, error);
	        }
	    }, {
	        key: 'createUserWithInvite',
	        value: function createUserWithInvite(user, data, emailHash, inviteId, success, error) {
	            var url = this.getUsersRoute() + '/create';
	
	            url += '?d=' + encodeURIComponent(data);
	
	            if (emailHash) {
	                url += '&h=' + encodeURIComponent(emailHash);
	            }
	
	            if (inviteId) {
	                url += '&iid=' + encodeURIComponent(inviteId);
	            }
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(url).set(this.defaultHeaders).type('application/json').accept('application/json').send(user).end(this.handleResponse.bind(this, 'createUser', success, error));
	
	            this.track('api', 'api_users_create', '', 'email', user.email);
	        }
	    }, {
	        key: 'updateUser',
	        value: function updateUser(user, type, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getUsersRoute() + '/update').set(this.defaultHeaders).type('application/json').accept('application/json').send(user).end(this.handleResponse.bind(this, 'updateUser', success, error));
	
	            if (type) {
	                this.track('api', 'api_users_update_' + type);
	            } else {
	                this.track('api', 'api_users_update');
	            }
	        }
	    }, {
	        key: 'updatePassword',
	        value: function updatePassword(userId, currentPassword, newPassword, success, error) {
	            var data = {};
	            data.user_id = userId;
	            data.current_password = currentPassword;
	            data.new_password = newPassword;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getUsersRoute() + '/newpassword').set(this.defaultHeaders).type('application/json').accept('application/json').send(data).end(this.handleResponse.bind(this, 'updatePassword', success, error));
	
	            this.track('api', 'api_users_newpassword');
	        }
	    }, {
	        key: 'updateUserNotifyProps',
	        value: function updateUserNotifyProps(notifyProps, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getUsersRoute() + '/update_notify').set(this.defaultHeaders).type('application/json').accept('application/json').send(notifyProps).end(this.handleResponse.bind(this, 'updateUserNotifyProps', success, error));
	
	            this.track('api', 'api_users_update_notification_settings');
	        }
	    }, {
	        key: 'updateRoles',
	        value: function updateRoles(teamId, userId, newRoles, success, error) {
	            var data = {
	                team_id: teamId,
	                user_id: userId,
	                new_roles: newRoles
	            };
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getUsersRoute() + '/update_roles').set(this.defaultHeaders).type('application/json').accept('application/json').send(data).end(this.handleResponse.bind(this, 'updateRoles', success, error));
	
	            this.track('api', 'api_users_update_roles');
	        }
	    }, {
	        key: 'updateActive',
	        value: function updateActive(userId, active, success, error) {
	            var data = {};
	            data.user_id = userId;
	            data.active = '' + active;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getUsersRoute() + '/update_active').set(this.defaultHeaders).type('application/json').accept('application/json').send(data).end(this.handleResponse.bind(this, 'updateActive', success, error));
	
	            this.track('api', 'api_users_update_roles');
	        }
	    }, {
	        key: 'sendPasswordReset',
	        value: function sendPasswordReset(email, success, error) {
	            var data = {};
	            data.email = email;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getUsersRoute() + '/send_password_reset').set(this.defaultHeaders).type('application/json').accept('application/json').send(data).end(this.handleResponse.bind(this, 'sendPasswordReset', success, error));
	
	            this.track('api', 'api_users_send_password_reset');
	        }
	    }, {
	        key: 'resetPassword',
	        value: function resetPassword(code, newPassword, success, error) {
	            var data = {};
	            data.new_password = newPassword;
	            data.code = code;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getUsersRoute() + '/reset_password').set(this.defaultHeaders).type('application/json').accept('application/json').send(data).end(this.handleResponse.bind(this, 'resetPassword', success, error));
	
	            this.track('api', 'api_users_reset_password');
	        }
	    }, {
	        key: 'emailToOAuth',
	        value: function emailToOAuth(email, password, service, success, error) {
	            var data = {};
	            data.password = password;
	            data.email = email;
	            data.service = service;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getUsersRoute() + '/claim/email_to_oauth').set(this.defaultHeaders).type('application/json').accept('application/json').send(data).end(this.handleResponse.bind(this, 'emailToOAuth', success, error));
	
	            this.track('api', 'api_users_email_to_oauth');
	        }
	    }, {
	        key: 'oauthToEmail',
	        value: function oauthToEmail(email, password, success, error) {
	            var data = {};
	            data.password = password;
	            data.email = email;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getUsersRoute() + '/claim/oauth_to_email').set(this.defaultHeaders).type('application/json').accept('application/json').send(data).end(this.handleResponse.bind(this, 'oauthToEmail', success, error));
	
	            this.track('api', 'api_users_oauth_to_email');
	        }
	    }, {
	        key: 'emailToLdap',
	        value: function emailToLdap(email, password, ldapId, ldapPassword, success, error) {
	            var data = {};
	            data.email_password = password;
	            data.email = email;
	            data.ldap_id = ldapId;
	            data.ldap_password = ldapPassword;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getUsersRoute() + '/claim/email_to_ldap').set(this.defaultHeaders).type('application/json').accept('application/json').send(data).end(this.handleResponse.bind(this, 'emailToLdap', success, error));
	
	            this.track('api', 'api_users_email_to_ldap');
	        }
	    }, {
	        key: 'ldapToEmail',
	        value: function ldapToEmail(email, emailPassword, ldapPassword, success, error) {
	            var data = {};
	            data.email = email;
	            data.ldap_password = ldapPassword;
	            data.email_password = emailPassword;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getUsersRoute() + '/claim/ldap_to_email').set(this.defaultHeaders).type('application/json').accept('application/json').send(data).end(this.handleResponse.bind(this, 'ldapToEmail', success, error));
	
	            this.track('api', 'api_users_oauth_to_email');
	        }
	    }, {
	        key: 'getInitialLoad',
	        value: function getInitialLoad(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getUsersRoute() + '/initial_load').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getInitialLoad', success, error));
	        }
	    }, {
	        key: 'getMe',
	        value: function getMe(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getUsersRoute() + '/me').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getMe', success, error));
	        }
	    }, {
	        key: 'login',
	        value: function login(loginId, password, mfaToken, success, error) {
	            this.doLogin({ login_id: loginId, password: password, token: mfaToken }, success, error);
	
	            this.track('api', 'api_users_login', '', 'login_id', loginId);
	        }
	    }, {
	        key: 'loginById',
	        value: function loginById(id, password, mfaToken, success, error) {
	            this.doLogin({ id: id, password: password, token: mfaToken }, success, error);
	
	            this.track('api', 'api_users_login', '', 'id', id);
	        }
	    }, {
	        key: 'loginByLdap',
	        value: function loginByLdap(loginId, password, mfaToken, success, error) {
	            this.doLogin({ login_id: loginId, password: password, token: mfaToken, ldap_only: 'true' }, success, error);
	
	            this.track('api', 'api_users_login', '', 'login_id', loginId);
	        }
	    }, {
	        key: 'doLogin',
	        value: function doLogin(outgoingData, success, error) {
	            var outer = this; // eslint-disable-line consistent-this
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getUsersRoute() + '/login').set(this.defaultHeaders).type('application/json').accept('application/json').send(outgoingData).end(this.handleResponse.bind(this, 'login', function (data, res) {
	                if (res && res.header) {
	                    outer.token = res.header[HEADER_TOKEN];
	
	                    if (outer.useToken) {
	                        outer.defaultHeaders[HEADER_AUTH] = HEADER_BEARER + ' ' + outer.token;
	                    }
	                }
	
	                if (success) {
	                    success(data, res);
	                }
	            }, error));
	        }
	    }, {
	        key: 'logout',
	        value: function logout(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getUsersRoute() + '/logout').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'logout', success, error));
	
	            this.track('api', 'api_users_logout');
	        }
	    }, {
	        key: 'checkMfa',
	        value: function checkMfa(loginId, success, error) {
	            var data = {
	                login_id: loginId
	            };
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getUsersRoute() + '/mfa').set(this.defaultHeaders).type('application/json').accept('application/json').send(data).end(this.handleResponse.bind(this, 'checkMfa', success, error));
	
	            this.track('api', 'api_users_oauth_to_email');
	        }
	    }, {
	        key: 'revokeSession',
	        value: function revokeSession(altId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getUsersRoute() + '/revoke_session').set(this.defaultHeaders).type('application/json').accept('application/json').send({ id: altId }).end(this.handleResponse.bind(this, 'revokeSession', success, error));
	        }
	    }, {
	        key: 'getSessions',
	        value: function getSessions(userId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getUserNeededRoute(userId) + '/sessions').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getSessions', success, error));
	        }
	    }, {
	        key: 'getAudits',
	        value: function getAudits(userId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getUserNeededRoute(userId) + '/audits').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getAudits', success, error));
	        }
	    }, {
	        key: 'getRecentlyActiveUsers',
	        value: function getRecentlyActiveUsers(id, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getAdminRoute() + '/recently_active_users/' + id).set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getRecentlyActiveUsers', success, error));
	        }
	    }, {
	        key: 'getDirectProfiles',
	        value: function getDirectProfiles(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getUsersRoute() + '/direct_profiles').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getDirectProfiles', success, error));
	        }
	    }, {
	        key: 'getProfiles',
	        value: function getProfiles(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getUsersRoute() + '/profiles/' + this.getTeamId()).set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getProfiles', success, error));
	        }
	    }, {
	        key: 'getProfilesForTeam',
	        value: function getProfilesForTeam(teamId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getUsersRoute() + '/profiles/' + teamId).set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getProfilesForTeam', success, error));
	        }
	    }, {
	        key: 'getProfilesForDirectMessageList',
	        value: function getProfilesForDirectMessageList(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getUsersRoute() + '/profiles_for_dm_list/' + this.getTeamId()).set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getProfilesForDirectMessageList', success, error));
	        }
	    }, {
	        key: 'getStatuses',
	        value: function getStatuses(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getUsersRoute() + '/status').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getStatuses', success, error));
	        }
	    }, {
	        key: 'setActiveChannel',
	        value: function setActiveChannel(id, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getUsersRoute() + '/status/set_active_channel').set(this.defaultHeaders).type('application/json').accept('application/json').send({ channel_id: id }).end(this.handleResponse.bind(this, 'setActiveChannel', success, error));
	        }
	    }, {
	        key: 'verifyEmail',
	        value: function verifyEmail(uid, hid, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getUsersRoute() + '/verify_email').set(this.defaultHeaders).type('application/json').accept('application/json').send({ uid: uid, hid: hid }).end(this.handleResponse.bind(this, 'verifyEmail', success, error));
	        }
	    }, {
	        key: 'resendVerification',
	        value: function resendVerification(email, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getUsersRoute() + '/resend_verification').set(this.defaultHeaders).type('application/json').accept('application/json').send({ email: email }).end(this.handleResponse.bind(this, 'resendVerification', success, error));
	        }
	    }, {
	        key: 'updateMfa',
	        value: function updateMfa(token, activate, success, error) {
	            var data = {};
	            data.activate = activate;
	            data.token = token;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getUsersRoute() + '/update_mfa').set(this.defaultHeaders).type('application/json').accept('application/json').send(data).end(this.handleResponse.bind(this, 'updateMfa', success, error));
	        }
	    }, {
	        key: 'uploadProfileImage',
	        value: function uploadProfileImage(image, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getUsersRoute() + '/newimage').set(this.defaultHeaders).attach('image', image, image.name).accept('application/json').end(this.handleResponse.bind(this, 'uploadProfileImage', success, error));
	
	            this.track('api', 'api_users_update_profile_picture');
	        }
	
	        // Channel Routes Section
	
	    }, {
	        key: 'createChannel',
	        value: function createChannel(channel, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getChannelsRoute() + '/create').set(this.defaultHeaders).type('application/json').accept('application/json').send(channel).end(this.handleResponse.bind(this, 'createChannel', success, error));
	
	            this.track('api', 'api_channels_create', channel.type, 'name', channel.name);
	        }
	    }, {
	        key: 'createDirectChannel',
	        value: function createDirectChannel(userId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getChannelsRoute() + '/create_direct').set(this.defaultHeaders).type('application/json').accept('application/json').send({ user_id: userId }).end(this.handleResponse.bind(this, 'createDirectChannel', success, error));
	        }
	    }, {
	        key: 'updateChannel',
	        value: function updateChannel(channel, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getChannelsRoute() + '/update').set(this.defaultHeaders).type('application/json').accept('application/json').send(channel).end(this.handleResponse.bind(this, 'updateChannel', success, error));
	
	            this.track('api', 'api_channels_update');
	        }
	    }, {
	        key: 'updateChannelHeader',
	        value: function updateChannelHeader(channelId, header, success, error) {
	            var data = {
	                channel_id: channelId,
	                channel_header: header
	            };
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getChannelsRoute() + '/update_header').set(this.defaultHeaders).type('application/json').accept('application/json').send(data).end(this.handleResponse.bind(this, 'updateChannel', success, error));
	
	            this.track('api', 'api_channels_header');
	        }
	    }, {
	        key: 'updateChannelPurpose',
	        value: function updateChannelPurpose(channelId, purpose, success, error) {
	            var data = {
	                channel_id: channelId,
	                channel_purpose: purpose
	            };
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getChannelsRoute() + '/update_purpose').set(this.defaultHeaders).type('application/json').accept('application/json').send(data).end(this.handleResponse.bind(this, 'updateChannelPurpose', success, error));
	
	            this.track('api', 'api_channels_purpose');
	        }
	    }, {
	        key: 'updateChannelNotifyProps',
	        value: function updateChannelNotifyProps(data, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getChannelsRoute() + '/update_notify_props').set(this.defaultHeaders).type('application/json').accept('application/json').send(data).end(this.handleResponse.bind(this, 'updateChannelNotifyProps', success, error));
	        }
	    }, {
	        key: 'leaveChannel',
	        value: function leaveChannel(channelId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getChannelNeededRoute(channelId) + '/leave').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'leaveChannel', success, error));
	
	            this.track('api', 'api_channels_leave');
	        }
	    }, {
	        key: 'joinChannel',
	        value: function joinChannel(channelId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getChannelNeededRoute(channelId) + '/join').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'joinChannel', success, error));
	
	            this.track('api', 'api_channels_join');
	        }
	    }, {
	        key: 'joinChannelByName',
	        value: function joinChannelByName(name, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getChannelNameRoute(name) + '/join').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'joinChannelByName', success, error));
	
	            this.track('api', 'api_channels_join_name');
	        }
	    }, {
	        key: 'deleteChannel',
	        value: function deleteChannel(channelId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getChannelNeededRoute(channelId) + '/delete').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'deleteChannel', success, error));
	
	            this.track('api', 'api_channels_delete');
	        }
	    }, {
	        key: 'updateLastViewedAt',
	        value: function updateLastViewedAt(channelId, active, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getChannelNeededRoute(channelId) + '/update_last_viewed_at').set(this.defaultHeaders).type('application/json').accept('application/json').send({ active: active }).end(this.handleResponse.bind(this, 'updateLastViewedAt', success, error));
	        }
	    }, {
	        key: 'setLastViewedAt',
	        value: function setLastViewedAt(channelId, lastViewedAt, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getChannelNeededRoute(channelId) + '/set_last_viewed_at').set(this.defaultHeaders).type('application/json').accept('application/json').send({ last_viewed_at: lastViewedAt }).end(this.handleResponse.bind(this, 'setLastViewedAt', success, error));
	        }
	    }, {
	        key: 'getChannels',
	        value: function getChannels(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getChannelsRoute() + '/').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getChannels', success, error));
	        }
	    }, {
	        key: 'getChannel',
	        value: function getChannel(channelId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getChannelNeededRoute(channelId) + '/').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getChannel', success, error));
	
	            this.track('api', 'api_channel_get');
	        }
	    }, {
	        key: 'getMoreChannels',
	        value: function getMoreChannels(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getChannelsRoute() + '/more').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getMoreChannels', success, error));
	        }
	    }, {
	        key: 'getChannelCounts',
	        value: function getChannelCounts(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getChannelsRoute() + '/counts').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getChannelCounts', success, error));
	        }
	    }, {
	        key: 'getChannelExtraInfo',
	        value: function getChannelExtraInfo(channelId, memberLimit, success, error) {
	            var url = this.getChannelNeededRoute(channelId) + '/extra_info';
	            if (memberLimit) {
	                url += '/' + memberLimit;
	            }
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(url).set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getChannelExtraInfo', success, error));
	        }
	    }, {
	        key: 'addChannelMember',
	        value: function addChannelMember(channelId, userId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getChannelNeededRoute(channelId) + '/add').set(this.defaultHeaders).type('application/json').accept('application/json').send({ user_id: userId }).end(this.handleResponse.bind(this, 'addChannelMember', success, error));
	
	            this.track('api', 'api_channels_add_member');
	        }
	    }, {
	        key: 'removeChannelMember',
	        value: function removeChannelMember(channelId, userId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getChannelNeededRoute(channelId) + '/remove').set(this.defaultHeaders).type('application/json').accept('application/json').send({ user_id: userId }).end(this.handleResponse.bind(this, 'removeChannelMember', success, error));
	
	            this.track('api', 'api_channels_remove_member');
	        }
	
	        // Routes for Commands
	
	    }, {
	        key: 'listCommands',
	        value: function listCommands(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getCommandsRoute() + '/list').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'listCommands', success, error));
	        }
	    }, {
	        key: 'executeCommand',
	        value: function executeCommand(channelId, command, suggest, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getCommandsRoute() + '/execute').set(this.defaultHeaders).type('application/json').accept('application/json').send({ channelId: channelId, command: command, suggest: '' + suggest }).end(this.handleResponse.bind(this, 'executeCommand', success, error));
	
	            this.track('api', 'api_integrations_used');
	        }
	    }, {
	        key: 'addCommand',
	        value: function addCommand(command, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getCommandsRoute() + '/create').set(this.defaultHeaders).type('application/json').accept('application/json').send(command).end(this.handleResponse.bind(this, 'addCommand', success, error));
	
	            this.track('api', 'api_integrations_created');
	        }
	    }, {
	        key: 'deleteCommand',
	        value: function deleteCommand(commandId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getCommandsRoute() + '/delete').set(this.defaultHeaders).type('application/json').accept('application/json').send({ id: commandId }).end(this.handleResponse.bind(this, 'deleteCommand', success, error));
	
	            this.track('api', 'api_integrations_deleted');
	        }
	    }, {
	        key: 'listTeamCommands',
	        value: function listTeamCommands(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getCommandsRoute() + '/list_team_commands').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'listTeamCommands', success, error));
	        }
	    }, {
	        key: 'regenCommandToken',
	        value: function regenCommandToken(commandId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getCommandsRoute() + '/regen_token').set(this.defaultHeaders).type('application/json').accept('application/json').send({ id: commandId }).end(this.handleResponse.bind(this, 'regenCommandToken', success, error));
	        }
	
	        // Routes for Posts
	
	    }, {
	        key: 'createPost',
	        value: function createPost(post, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getPostsRoute(post.channel_id) + '/create').set(this.defaultHeaders).type('application/json').accept('application/json').send(post).end(this.handleResponse.bind(this, 'createPost', success, error));
	
	            this.track('api', 'api_posts_create', post.channel_id, 'length', post.message.length);
	
	            if (post.message.match(/\s#./)) {
	                this.track('api', 'api_posts_hashtag');
	            }
	
	            if (post.message.match(/\s@./)) {
	                this.track('api', 'api_posts_mentions');
	            }
	        }
	
	        // This is a temporary route to get around a problem with the permissions system that
	        // will be fixed in 3.1 or 3.2
	
	    }, {
	        key: 'getPermalinkTmp',
	        value: function getPermalinkTmp(postId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getTeamNeededRoute() + '/pltmp/' + postId).set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getPermalinkTmp', success, error));
	        }
	    }, {
	        key: 'getPostById',
	        value: function getPostById(postId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getTeamNeededRoute() + '/posts/' + postId).set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getPostById', success, error));
	        }
	    }, {
	        key: 'getPost',
	        value: function getPost(channelId, postId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getChannelNeededRoute(channelId) + '/posts/' + postId + '/get').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getPost', success, error));
	        }
	    }, {
	        key: 'updatePost',
	        value: function updatePost(post, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getPostsRoute(post.channel_id) + '/update').set(this.defaultHeaders).type('application/json').accept('application/json').send(post).end(this.handleResponse.bind(this, 'updatePost', success, error));
	
	            this.track('api', 'api_posts_update');
	        }
	    }, {
	        key: 'deletePost',
	        value: function deletePost(channelId, postId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getChannelNeededRoute(channelId) + '/posts/' + postId + '/delete').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'deletePost', success, error));
	
	            this.track('api', 'api_posts_delete');
	        }
	    }, {
	        key: 'search',
	        value: function search(terms, isOrSearch, success, error) {
	            var data = {};
	            data.terms = terms;
	            data.is_or_search = isOrSearch;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getTeamNeededRoute() + '/posts/search').set(this.defaultHeaders).type('application/json').accept('application/json').send(data).end(this.handleResponse.bind(this, 'search', success, error));
	
	            this.track('api', 'api_posts_search');
	        }
	    }, {
	        key: 'getPostsPage',
	        value: function getPostsPage(channelId, offset, limit, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getPostsRoute(channelId) + '/page/' + offset + '/' + limit).set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getPostsPage', success, error));
	        }
	    }, {
	        key: 'getPosts',
	        value: function getPosts(channelId, since, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getPostsRoute(channelId) + '/since/' + since).set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getPosts', success, error));
	        }
	    }, {
	        key: 'getPostsBefore',
	        value: function getPostsBefore(channelId, postId, offset, numPost, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getPostsRoute(channelId) + '/' + postId + '/before/' + offset + '/' + numPost).set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getPostsBefore', success, error));
	        }
	    }, {
	        key: 'getPostsAfter',
	        value: function getPostsAfter(channelId, postId, offset, numPost, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getPostsRoute(channelId) + '/' + postId + '/after/' + offset + '/' + numPost).set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getPostsAfter', success, error));
	        }
	    }, {
	        key: 'getFlaggedPosts',
	        value: function getFlaggedPosts(offset, limit, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getTeamNeededRoute() + '/posts/flagged/' + offset + '/' + limit).set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getFlaggedPosts', success, error));
	        }
	
	        // Routes for Files
	
	    }, {
	        key: 'getFileInfo',
	        value: function getFileInfo(filename, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getFilesRoute() + '/get_info' + filename).set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getFileInfo', success, error));
	        }
	    }, {
	        key: 'getPublicLink',
	        value: function getPublicLink(filename, success, error) {
	            var data = {
	                filename: filename
	            };
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getFilesRoute() + '/get_public_link').set(this.defaultHeaders).type('application/json').accept('application/json').send(data).end(this.handleResponse.bind(this, 'getPublicLink', success, error));
	        }
	    }, {
	        key: 'uploadFile',
	        value: function uploadFile(file, filename, channelId, clientId, success, error) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getFilesRoute() + '/upload').set(this.defaultHeaders).attach('files', file, filename).field('channel_id', channelId).field('client_ids', clientId).accept('application/json').end(this.handleResponse.bind(this, 'uploadFile', success, error));
	        }
	
	        // Routes for OAuth
	
	    }, {
	        key: 'registerOAuthApp',
	        value: function registerOAuthApp(app, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getOAuthRoute() + '/register').set(this.defaultHeaders).type('application/json').accept('application/json').send(app).end(this.handleResponse.bind(this, 'registerOAuthApp', success, error));
	
	            this.track('api', 'api_apps_register');
	        }
	    }, {
	        key: 'allowOAuth2',
	        value: function allowOAuth2(responseType, clientId, redirectUri, state, scope, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getOAuthRoute() + '/allow').set(this.defaultHeaders).type('application/json').accept('application/json').query({ response_type: responseType }).query({ client_id: clientId }).query({ redirect_uri: redirectUri }).query({ scope: scope }).query({ state: state }).end(this.handleResponse.bind(this, 'allowOAuth2', success, error));
	        }
	    }, {
	        key: 'listOAuthApps',
	        value: function listOAuthApps(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getOAuthRoute() + '/list').set(this.defaultHeaders).type('application/json').accept('application/json').send().end(this.handleResponse.bind(this, 'getOAuthApps', success, error));
	        }
	    }, {
	        key: 'deleteOAuthApp',
	        value: function deleteOAuthApp(id, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getOAuthRoute() + '/delete').set(this.defaultHeaders).type('application/json').accept('application/json').send({ id: id }).end(this.handleResponse.bind(this, 'deleteOAuthApp', success, error));
	        }
	    }, {
	        key: 'getOAuthAppInfo',
	        value: function getOAuthAppInfo(id, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getOAuthRoute() + '/app/' + id).set(this.defaultHeaders).type('application/json').accept('application/json').send().end(this.handleResponse.bind(this, 'getOAuthAppInfo', success, error));
	        }
	    }, {
	        key: 'getAuthorizedApps',
	        value: function getAuthorizedApps(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getOAuthRoute() + '/authorized').set(this.defaultHeaders).type('application/json').accept('application/json').send().end(this.handleResponse.bind(this, 'getAuthorizedApps', success, error));
	        }
	    }, {
	        key: 'deauthorizeOAuthApp',
	        value: function deauthorizeOAuthApp(id, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getOAuthRoute() + '/' + id + '/deauthorize').set(this.defaultHeaders).type('application/json').accept('application/json').send().end(this.handleResponse.bind(this, 'deauthorizeOAuthApp', success, error));
	        }
	    }, {
	        key: 'regenerateOAuthAppSecret',
	        value: function regenerateOAuthAppSecret(id, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getOAuthRoute() + '/' + id + '/regen_secret').set(this.defaultHeaders).type('application/json').accept('application/json').send().end(this.handleResponse.bind(this, 'regenerateOAuthAppSecret', success, error));
	        }
	
	        // Routes for Hooks
	
	    }, {
	        key: 'addIncomingHook',
	        value: function addIncomingHook(hook, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getHooksRoute() + '/incoming/create').set(this.defaultHeaders).type('application/json').accept('application/json').send(hook).end(this.handleResponse.bind(this, 'addIncomingHook', success, error));
	
	            this.track('api', 'api_integrations_created');
	        }
	    }, {
	        key: 'deleteIncomingHook',
	        value: function deleteIncomingHook(hookId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getHooksRoute() + '/incoming/delete').set(this.defaultHeaders).type('application/json').accept('application/json').send({ id: hookId }).end(this.handleResponse.bind(this, 'deleteIncomingHook', success, error));
	
	            this.track('api', 'api_integrations_deleted');
	        }
	    }, {
	        key: 'listIncomingHooks',
	        value: function listIncomingHooks(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getHooksRoute() + '/incoming/list').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'listIncomingHooks', success, error));
	        }
	    }, {
	        key: 'addOutgoingHook',
	        value: function addOutgoingHook(hook, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getHooksRoute() + '/outgoing/create').set(this.defaultHeaders).type('application/json').accept('application/json').send(hook).end(this.handleResponse.bind(this, 'addOutgoingHook', success, error));
	
	            this.track('api', 'api_integrations_created');
	        }
	    }, {
	        key: 'deleteOutgoingHook',
	        value: function deleteOutgoingHook(hookId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getHooksRoute() + '/outgoing/delete').set(this.defaultHeaders).type('application/json').accept('application/json').send({ id: hookId }).end(this.handleResponse.bind(this, 'deleteOutgoingHook', success, error));
	
	            this.track('api', 'api_integrations_deleted');
	        }
	    }, {
	        key: 'listOutgoingHooks',
	        value: function listOutgoingHooks(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getHooksRoute() + '/outgoing/list').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'listOutgoingHooks', success, error));
	        }
	    }, {
	        key: 'regenOutgoingHookToken',
	        value: function regenOutgoingHookToken(hookId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getHooksRoute() + '/outgoing/regen_token').set(this.defaultHeaders).type('application/json').accept('application/json').send({ id: hookId }).end(this.handleResponse.bind(this, 'regenOutgoingHookToken', success, error));
	        }
	
	        // Routes for Preferences
	
	    }, {
	        key: 'getAllPreferences',
	        value: function getAllPreferences(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getBaseRoute() + '/preferences/').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getAllPreferences', success, error));
	        }
	    }, {
	        key: 'savePreferences',
	        value: function savePreferences(preferences, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getBaseRoute() + '/preferences/save').set(this.defaultHeaders).type('application/json').accept('application/json').send(preferences).end(this.handleResponse.bind(this, 'savePreferences', success, error));
	        }
	    }, {
	        key: 'getPreferenceCategory',
	        value: function getPreferenceCategory(category, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getBaseRoute() + '/preferences/' + category).set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'getPreferenceCategory', success, error));
	        }
	    }, {
	        key: 'deletePreferences',
	        value: function deletePreferences(preferences, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getBaseRoute() + '/preferences/delete').set(this.defaultHeaders).type('application/json').accept('application/json').send(preferences).end(this.handleResponse.bind(this, 'deletePreferences', success, error));
	        }
	
	        // Routes for Emoji
	
	    }, {
	        key: 'listEmoji',
	        value: function listEmoji(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getEmojiRoute() + '/list').set(this.defaultHeaders).type('application/json').accept('application/json').end(this.handleResponse.bind(this, 'listEmoji', success, error));
	        }
	    }, {
	        key: 'addEmoji',
	        value: function addEmoji(emoji, image, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getEmojiRoute() + '/create').set(this.defaultHeaders).accept('application/json').attach('image', image, image.name).field('emoji', /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a.bind()(emoji)).end(this.handleResponse.bind(this, 'addEmoji', success, error));
	        }
	    }, {
	        key: 'deleteEmoji',
	        value: function deleteEmoji(id, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getEmojiRoute() + '/delete').set(this.defaultHeaders).accept('application/json').send({ id: id }).end(this.handleResponse.bind(this, 'deleteEmoji', success, error));
	        }
	    }, {
	        key: 'getCustomEmojiImageUrl',
	        value: function getCustomEmojiImageUrl(id) {
	            return this.getEmojiRoute() + '/' + id;
	        }
	    }, {
	        key: 'uploadCertificateFile',
	        value: function uploadCertificateFile(file, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getAdminRoute() + '/add_certificate').set(this.defaultHeaders).accept('application/json').attach('certificate', file, file.name).end(this.handleResponse.bind(this, 'uploadCertificateFile', success, error));
	        }
	    }, {
	        key: 'removeCertificateFile',
	        value: function removeCertificateFile(filename, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(this.getAdminRoute() + '/remove_certificate').set(this.defaultHeaders).accept('application/json').send({ filename: filename }).end(this.handleResponse.bind(this, 'removeCertificateFile', success, error));
	        }
	    }, {
	        key: 'samlCertificateStatus',
	        value: function samlCertificateStatus(success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.get(this.getAdminRoute() + '/saml_cert_status').set(this.defaultHeaders).type('application/json').accept('application/json').end(function (err, res) {
	                if (err) {
	                    return error(err);
	                }
	                return success(res.body);
	            });
	        }
	    }]);
	
	    return Client;
	}();
	
	/* harmony default export */ exports["a"] = Client;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	var MAX_WEBSOCKET_FAILS = 7;
	var MIN_WEBSOCKET_RETRY_TIME = 3000; // 3 sec
	var MAX_WEBSOCKET_RETRY_TIME = 300000; // 5 mins
	
	var WebSocketClient = function () {
	    function WebSocketClient() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, WebSocketClient);
	
	        this.conn = null;
	        this.sequence = 1;
	        this.connectFailCount = 0;
	        this.eventCallback = null;
	        this.responseCallbacks = {};
	        this.reconnectCallback = null;
	        this.errorCallback = null;
	        this.closeCallback = null;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(WebSocketClient, [{
	        key: 'initialize',
	        value: function initialize(connectionUrl) {
	            var _this = this;
	
	            if (this.conn) {
	                return;
	            }
	
	            if (this.connectFailCount === 0) {
	                console.log('websocket connecting to ' + connectionUrl); //eslint-disable-line no-console
	            }
	
	            this.conn = new WebSocket(connectionUrl);
	
	            this.conn.onopen = function () {
	                if (_this.reconnectCallback) {
	                    _this.reconnectCallback();
	                }
	
	                if (_this.connectFailCount > 0) {
	                    console.log('websocket re-established connection'); //eslint-disable-line no-console
	                }
	
	                _this.connectFailCount = 0;
	            };
	
	            this.conn.onclose = function () {
	                _this.conn = null;
	                _this.sequence = 1;
	
	                if (_this.connectFailCount === 0) {
	                    console.log('websocket closed'); //eslint-disable-line no-console
	                }
	
	                _this.connectFailCount++;
	
	                if (_this.closeCallback) {
	                    _this.closeCallback(_this.connectFailCount);
	                }
	
	                var retryTime = MIN_WEBSOCKET_RETRY_TIME;
	
	                // If we've failed a bunch of connections then start backing off
	                if (_this.connectFailCount > MAX_WEBSOCKET_FAILS) {
	                    retryTime = MIN_WEBSOCKET_RETRY_TIME * _this.connectFailCount * _this.connectFailCount;
	                    if (retryTime > MAX_WEBSOCKET_RETRY_TIME) {
	                        retryTime = MAX_WEBSOCKET_RETRY_TIME;
	                    }
	                }
	
	                setTimeout(function () {
	                    _this.initialize(connectionUrl);
	                }, retryTime);
	            };
	
	            this.conn.onerror = function (evt) {
	                if (_this.connectFailCount <= 1) {
	                    console.log('websocket error'); //eslint-disable-line no-console
	                    console.log(evt); //eslint-disable-line no-console
	                }
	
	                if (_this.errorCallback) {
	                    _this.errorCallback(evt);
	                }
	            };
	
	            this.conn.onmessage = function (evt) {
	                var msg = JSON.parse(evt.data);
	                if (msg.seq_reply) {
	                    if (msg.error) {
	                        console.log(msg); //eslint-disable-line no-console
	                    }
	
	                    if (_this.responseCallbacks[msg.seq_reply]) {
	                        _this.responseCallbacks[msg.seq_reply](msg);
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property___default.a.bind()(_this.responseCallbacks, msg.seq_reply);
	                    }
	                } else if (_this.eventCallback) {
	                    _this.eventCallback(msg);
	                }
	            };
	        }
	    }, {
	        key: 'setEventCallback',
	        value: function setEventCallback(callback) {
	            this.eventCallback = callback;
	        }
	    }, {
	        key: 'setReconnectCallback',
	        value: function setReconnectCallback(callback) {
	            this.reconnectCallback = callback;
	        }
	    }, {
	        key: 'setErrorCallback',
	        value: function setErrorCallback(callback) {
	            this.errorCallback = callback;
	        }
	    }, {
	        key: 'setCloseCallback',
	        value: function setCloseCallback(callback) {
	            this.closeCallback = callback;
	        }
	    }, {
	        key: 'close',
	        value: function close() {
	            this.connectFailCount = 0;
	            this.sequence = 1;
	            if (this.conn && this.conn.readyState === WebSocket.OPEN) {
	                this.conn.onclose = function () {}; //eslint-disable-line no-empty-function
	                this.conn.close();
	                this.conn = null;
	                console.log('websocket closed'); //eslint-disable-line no-console
	            }
	        }
	    }, {
	        key: 'sendMessage',
	        value: function sendMessage(action, data, responseCallback) {
	            var msg = {
	                action: action,
	                seq: this.sequence++,
	                data: data
	            };
	
	            if (responseCallback) {
	                this.responseCallbacks[msg.seq] = responseCallback;
	            }
	
	            if (this.conn && this.conn.readyState === WebSocket.OPEN) {
	                this.conn.send(/* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a.bind()(msg));
	            } else if (!this.conn || this.conn.readyState === WebSocket.Closed) {
	                this.conn = null;
	                this.initialize();
	            }
	        }
	    }, {
	        key: 'userTyping',
	        value: function userTyping(channelId, parentId) {
	            var data = {};
	            data.channel_id = channelId;
	            data.parent_id = parentId;
	
	            this.sendMessage('user_typing', data);
	        }
	    }, {
	        key: 'getStatuses',
	        value: function getStatuses(callback) {
	            this.sendMessage('get_statuses', null, callback);
	        }
	    }]);
	
	    return WebSocketClient;
	}();
	
	/* harmony default export */ exports["a"] = WebSocketClient;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client_jsx__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__websocket_client_jsx__ = __webpack_require__(4);
	
	
	
	module.exports.Client = /* harmony import */__WEBPACK_IMPORTED_MODULE_0__client_jsx__["a"];
	module.exports.WebSocketClient = /* harmony import */__WEBPACK_IMPORTED_MODULE_1__websocket_client_jsx__["a"];

/***/ },
/* 6 */
/***/ function(module, exports) {

	module.exports = require("babel-runtime/core-js/reflect/delete-property");

/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = require("superagent");

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** client.js
 **/